<app-menu></app-menu>

<div class="fundo-politicas uk-light">
    <div class="uk-container uk-text-center">
        <h1 class="hero-standard-title">Política de Privacidade</h1>
        <p class="uk-text-large" style="opacity: 0.9;">Sua privacidade é nossa prioridade.</p>
    </div>
</div>

<div class="uk-container uk-margin-large-bottom uk-margin-large-top">

<h2>1. Introdução</h2>
<p>A sua privacidade é uma prioridade para a Fluxo-Digital. Este documento descreve como coletamos, usamos, armazenamos e protegemos suas informações ao utilizar nossos serviços, em conformidade com a Lei n.º 22/11 de 17 de junho – Lei da Proteção de Dados Pessoais de Angola.</p>

<h2>2. Informações que Coletamos</h2>
<h3>2.1 Informações Pessoais</h3>
<ul>
    <li>Nome completo</li>
    <li>Endereço de e-mail</li>
    <li>Número de telefone</li>
    <li>Dados de faturamento e pagamento</li>
    <li>Informações de contacto para suporte técnico</li>
</ul>

<h3>2.2 Informações Automáticas</h3>
<ul>
    <li>Endereço IP</li>
    <li>Tipo de navegador e sistema operacional</li>
    <li>Páginas acessadas e tempo de navegação</li>
    <li>Dados de uso dos serviços contratados</li>
</ul>

<h3>2.3 Cookies e Tecnologias de Rastreamento</h3>
<p>Utilizamos cookies para melhorar a experiência do usuário, personalizar conteúdos e analisar o tráfego do site. O usuário pode gerenciar ou desativar cookies nas configurações do navegador.</p>

<h2>3. Como Usamos suas Informações</h2>
<ul>
    <li>Processar e gerenciar sua conta e serviços contratados.</li>
    <li>Fornecer suporte técnico e atendimento ao cliente.</li>
    <li>Melhorar nossos produtos e serviços com base no uso.</li>
    <li>Enviar comunicações importantes, como notificações sobre sua conta, atualizações de serviço e promoções (caso tenha consentido).</li>
    <li>Proteger nossos sistemas e prevenir atividades fraudulentas.</li>
</ul>

<h2>4. Compartilhamento de Informações</h2>
<p>A Fluxo-Digital <strong>NÃO</strong> vende, aluga ou compartilha suas informações pessoais com terceiros, exceto nos seguintes casos:</p>
<ul>
    <li><strong>Fornecedores e Parceiros de Serviço:</strong> Empresas que nos ajudam a fornecer infraestrutura, hospedagem e processamento de pagamentos.</li>
    <li><strong>Obrigação Legal:</strong> Quando exigido por lei, ordem judicial ou solicitação governamental válida.</li>
    <li><strong>Proteção contra Fraudes e Segurança:</strong> Para detectar e prevenir fraudes, abusos ou ameaças à segurança dos nossos serviços.</li>
</ul>

<h2>5. Armazenamento e Proteção dos Dados</h2>
<p>A Fluxo-Digital adota medidas rigorosas de segurança para proteger seus dados contra acesso não autorizado, alteração, divulgação ou destruição, incluindo:</p>
<ul>
    <li>Criptografia de dados sensíveis</li>
    <li>Acesso restrito a funcionários autorizados</li>
    <li>Monitoramento contínuo e proteção contra ataques cibernéticos</li>
</ul>

<h2>6. Seus Direitos e Controle sobre os Dados</h2>
<p>De acordo com a Lei n.º 22/11 de 17 de junho, você tem os seguintes direitos:</p>
<ul>
    <li><strong>Direito de Acesso:</strong> Solicitar confirmação sobre o tratamento de seus dados e acesso aos mesmos.</li>
    <li><strong>Direito de Retificação:</strong> Corrigir informações incorretas ou desatualizadas.</li>
    <li><strong>Direito de Eliminação:</strong> Solicitar a exclusão de seus dados, salvo quando exigido por lei mantê-los.</li>
    <li><strong>Direito de Oposição:</strong> Opor-se ao tratamento de seus dados para fins específicos.</li>
    <li><strong>Direito à Portabilidade:</strong> Solicitar a transferência de seus dados para outro fornecedor de serviço.</li>
</ul>
<p>Para exercer qualquer um desses direitos, entre em contacto pelo e-mail <a href="mailto:suporte@fluxodigital.ao">suporte&#64;fluxo-host.com</a>.</p>

<h2>7. Retenção de Dados</h2>
<p>Armazenamos seus dados apenas pelo tempo necessário para fornecer os serviços contratados, cumprir obrigações legais ou melhorar nossos serviços. Quando não forem mais necessários, os dados serão excluídos de forma segura.</p>

<h2>8. Transferência Internacional de Dados</h2>
<p>A Fluxo-Digital pode transferir seus dados pessoais para fora de Angola, garantindo que o país de destino ofereça um nível de proteção adequado ou que existam garantias apropriadas em conformidade com a Lei n.º 22/11 de 17 de junho.</p>

<h2>9. Medidas de Segurança</h2>
<p>Implementamos medidas técnicas e organizativas adequadas para proteger seus dados contra perda, uso indevido, acesso não autorizado, divulgação ou alteração. Nossos funcionários são treinados e comprometidos com a confidencialidade e proteção dos dados pessoais.</p>

<h2>10. Alterações nesta Política de Privacidade</h2>
<p>A Fluxo-Digital pode atualizar esta Política de Privacidade a qualquer momento. Notificaremos os usuários sobre mudanças significativas através do nosso site ou por e-mail.</p>

<h2>11. contacto</h2>
<p>Para dúvidas sobre esta política ou solicitações relacionadas à privacidade, entre em contacto com:</p>
<ul>
    <li><strong> E-mail:</strong> <a href="mailto:suporte@fluxodigital.ao">suporte&#64;fluxo-host.com</a></li>
    <li><strong> Site:</strong> <a href="https://fluxo-host.com">fluxo-digital.com</a></li>
</ul>
<p>Ao utilizar os serviços da Fluxo-Digital, você concorda com os termos desta Política de Privacidade.</p>


</div>

<app-rodape></app-rodape>

